const coreWalletLimitContextsForSelection = [
	'WalletAccountCreate',
	'WalletAccountCreatePerCurrency',
	'ShopConfigurationCreate',
	'PaymentInstrumentCreate',
	'LoginAttempt',
	'MasterPinAttempt',
	'FileExportCreate',
	'InvoiceCreate',
	'InvoiceConfirm',
	'PurchaseCreate',
	'PurchaseConfirm',
	'RefundCreate',
	'PaymentFund',
	'PaymentWithdraw',
	'P2PSend',
	'P2PReceive',
	'TradeOrder',
	'DepositCreate',
	'DepositThreshold',
	'VoucherP2PCreate',
	'VoucherP2PRedeem',
	'VoucherInvoiceCreate',
	'VoucherInvoiceRedeem'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitTypesForSelection = [
	'Amount',
	'Balance',
	'Count',
	'TurnOver'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitCurrencyTypesForSelection = [
	'ContextCurrency',
	'LeadCurrency'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitSubtypesForSelection = [
	'AvailableBalance',
	'ReservedBalance',
	'TotalBalance',
	'ExpectedAvailableBalance',
	'ExpectedReservedBalance',
	'ExpectedTotalBalance',
	'AmountGranularity',
	'None',
	'All',
	'Pending',
	'Completed',
	'Failed',
	'Main',
	'Shop'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitScopesForSelection = [
	'Wallet',
	'WalletAccount'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitPeriodsForSelection = [
	'Current',
	'LastMinutes',
	'LastHours',
	'LastDays',
	'LastMonths',
	'LastYears',
	'RunningMinutes',
	'RunningHours',
	'RunningDays',
	'RunningMonths',
	'RunningYears'
].map(key => {
	return { id: key, name: key };
});

const coreWalletLimitOperationsForSelection = [
	'Min',
	'Max'
].map(key => {
	return { id: key, name: key };
});

export {
	coreWalletLimitContextsForSelection,
	coreWalletLimitTypesForSelection,
	coreWalletLimitCurrencyTypesForSelection,
	coreWalletLimitSubtypesForSelection,
	coreWalletLimitScopesForSelection,
	coreWalletLimitPeriodsForSelection,
	coreWalletLimitOperationsForSelection
};
